<template>
  <div class="serial-wrap">
    <el-dialog title="设置格式" :visible.sync="setRulePage" :before-close="handleClose" width="500px">
      <div class="dialog-scroll">
        <!-- 预览框 -->
        <div class="preview-box">{{ rules }}</div>

        <draggable :list="defaultRules" group="option" handler=".drag-icon" :options="dragOption">
          <div v-for="(op, index) in defaultRules" :key="index" class="rule-row">
            <i class="el-icon-rank drag-icon"></i>
            <div class="rule-label">{{ title[op.type] }}</div>

            <el-input-number v-if="op.type === 'number'" v-model="op.autoIncrLength" size="small" clearable
              class="form-control" controls-position="right" :max="8" :min="1" />

            <el-select v-if="op.type === 'create_date'" v-model="op.rule" size="small" class="form-control">
              <el-option label="年" value="yyyy" />
              <el-option label="年月" value="yyyyMM" />
              <el-option label="年月日" value="yyyyMMdd" />
            </el-select>

            <el-select v-if="op.type === 'field'" v-model="op.rule" size="small" class="form-control">
              <el-option v-for="item in thisItemIdOptions" :key="item.id" :label="item.title" :value="item.code" />
            </el-select>

            <el-input v-if="op.type === 'text'" v-model="op.rule" size="small" clearable class="form-control"
              placeholder="请输入1~4个数字中英文或特殊字符" maxlength="4" />

            <i v-if="op.type !== 'number'" class="el-icon-delete del-icon" @click="delRules(index)" />
          </div>
        </draggable>

        <el-dropdown @command="handleCommand" size="small" class="add-dropdown" trigger="click">
          <el-button size="small">
            新增<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="create_date" :disabled="hasDateRule">提交日期</el-dropdown-item>
            <el-dropdown-item command="text">固定字符</el-dropdown-item>
            <el-dropdown-item command="field">表单控件</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <template slot="footer">
        <el-button size="small" @click="handleClose">取消</el-button>
        <el-button type="primary" size="small" @click="submit">确定</el-button>
      </template>
    </el-dialog>

    <!-- 头部标题栏 -->
    <div class="header-bar">
      <span class="header-title">流水号规则</span>
      <span class="set-btn" @click="setRule">设置</span>
    </div>

    <!-- 已配置规则展示 -->
    <div v-for="(op, index) in _option" :key="index" class="show-rule-row">
      {{ title[op.type] }}：{{ getShowText(op) }}
    </div>

    <!-- 自增计数标题 -->
    <div v-if="currentCount" class="count-title">自增位当前计数</div>

    <!-- 计数展示区域 -->
    <div v-if="currentCount && !resetCurrentCount" class="count-view">
      {{ currentCount.currentCount }}
      <span class="reset-text" @click="resetCurrentCount = true">重置</span>
    </div>

    <!-- 计数编辑输入框 -->
    <el-input v-else-if="currentCount" v-model="currentCount.currentCount" size="small">
      <el-button slot="append" @click="resetCurrentCount = false">完成</el-button>
    </el-input>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "SerialNumberConfig",
  components: { draggable },
  props: {
    formNumList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    // 是否已存在日期规则
    hasDateRule() {
      return this.defaultRules.some(item => item.type === 'create_date');
    },
    // 预览拼接最终流水号示例
    rules() {
      let str = "";
      this.defaultRules.forEach(item => {
        if (item.type === "text") {
          str += item.rule || '';
        } else if (item.type === "create_date") {
          str += this.formatDate(item.rule);
        } else if (item.type === "number") {
          const num = item.currentCount ?? 0;
          str += String(num).padStart(item.autoIncrLength, "0");
        }
      });
      return str;
    },
    // 获取自增配置项
    currentCount() {
      return this._option.find(item => item.type === "number");
    },
    // 双向绑定父传数组
    _option: {
      get() {
        return this.formNumList;
      },
      set(val) {
        this.$emit("update:formNumList", val);
      },
    },
    // 筛选可用表单控件
    thisItemIdOptions() {
      const list = [];
      const allowTypes = ["TextInput", "TextareaInput", "AmountInput", "SpanLayout"];
      const formItems = this.$store.state.design.formItems || [];

      formItems.forEach(item => {
        if (!allowTypes.includes(item.name) || !item.id) return;
        if (item.name === "SpanLayout") {
          item.items.forEach(sub => {
            if (allowTypes.includes(sub.name)) list.push(sub);
          });
        } else {
          list.push(item);
        }
      });
      return list;
    },
  },
  data() {
    return {
      dragOption: {
        animation: 300,
        sort: true,
      },
      setRulePage: false,
      defaultRules: [{ type: "number", autoIncrLength: 4 }],
      title: {
        number: "自增数字",
        text: "固定字符",
        field: "表单控件",
        create_date: "提交日期",
      },
      valueKey: {
        number: "autoIncrLength",
        text: "rule",
        field: "rule",
        create_date: "rule",
      },
      yearLabel: {
        yyyy: "年",
        yyyyMM: "年月",
        yyyyMMdd: "年月日",
      },
      resetCurrentCount: false,
    };
  },
  methods: {
    // 统一日期格式化工具
    formatDate(format) {
      const now = new Date();
      const y = now.getFullYear();
      const m = String(now.getMonth() + 1).padStart(2, '0');
      const d = String(now.getDate()).padStart(2, '0');
      switch (format) {
        case "yyyy": return String(y);
        case "yyyyMM": return `${y}${m}`;
        case "yyyyMMdd": return `${y}${m}${d}`;
        default: return '';
      }
    },
    // 列表展示文本处理
    getShowText(op) {
      if (op.type === "create_date") {
        return this.yearLabel[op.rule] || '';
      }
      return op[this.valueKey[op.type]] ?? '';
    },
    // 确定保存配置
    submit() {
      this._option = JSON.parse(JSON.stringify(this.defaultRules));
      this.handleClose();
    },
    // 删除单条规则
    delRules(index) {
      this.defaultRules.splice(index, 1);
    },
    // 下拉新增类型拦截（禁止新增自增数字）
    handleCommand(type) {
      if (type === 'number') return;
      const newItem = { type, rule: '' };
      this.defaultRules.push(newItem);
    },
    // 关闭弹窗重置数据
    handleClose() {
      this.setRulePage = false;
      this.$nextTick(() => {
        this.defaultRules = [];
      });
    },
    // 打开弹窗深拷贝原始配置
    setRule() {
      this.defaultRules = JSON.parse(JSON.stringify(this._option || []));
      this.setRulePage = true;
    },
  },
};
</script>

<style lang="less" scoped>
// 全局颜色尺寸变量统一
@color-text-normal: #606266;
@color-text-title: #304265;
@color-primary: #107fff;
@color-border-base: #dcdfe6;
@color-border-light: #e4e7ed;
@color-bg-gray: #f5f7fa;
@radius-sm: 4px;
@input-width: 300px;

.serial-wrap {
  padding-left: 22px;
  font-size: 14px;
  color: @color-text-normal;
}

.dialog-scroll {
  height: 260px;
  padding: 0 10px;
  overflow: auto;
}

.preview-box {
  width: 373px;
  height: 30px;
  margin: 0 auto 10px 23px;
  border: 1px solid @color-border-base;
  border-radius: @radius-sm;
  line-height: 30px;
  padding: 0 8px;
  text-align: center;
}

.rule-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  .drag-icon {
    margin-right: 10px;
    cursor: pointer;
  }

  .rule-label {
    height: 32px;
    border: 1px solid @color-border-base;
    border-right: none;
    border-radius: @radius-sm 0 0 @radius-sm;
    line-height: 32px;
    padding: 0 8px;
    margin-right: -2px;
  }

  .form-control {
    width: @input-width;
  }

  .del-icon {
    margin-left: 10px;
    cursor: pointer;

    &:hover {
      color: #f56c6c;
    }
  }
}

.add-dropdown {
  margin-left: 24px;
}

.header-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;

  .header-title {
    font-weight: 600;
    color: @color-text-title;
  }

  .set-btn {
    color: @color-primary;
    background: #fff;
    cursor: pointer;
  }
}

.show-rule-row {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.count-title {
  margin: 10px 0;
  font-weight: 600;
  color: @color-text-title;
}

.count-view {
  padding: 6px 14px;
  border: 1px solid @color-border-light;
  background-color: @color-bg-gray;
  border-radius: @radius-sm;

  .reset-text {
    float: right;
    color: @color-primary;
    cursor: pointer;
  }
}

// 深度修改element输入框圆角
/deep/ .rule-row .el-input__inner {
  border-radius: 0 @radius-sm @radius-sm 0;
}
</style>